export enum ViewCustomerTabs {
  feed,
  team,
  files,
  insights,
}
